"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BcmKunrenContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _bcmKunrenActions = require("./bcmKunrenActions");
var _KunrenDocMngMain = _interopRequireDefault(require("./kunrenDocMng/KunrenDocMngMain"));
var _KunrenGuidanceDeleteResult = _interopRequireDefault(require("./kunrenGuidanceRegister/KunrenGuidanceDeleteResult"));
var _KunrenGuidanceEntry = _interopRequireDefault(require("./kunrenGuidanceRegister/KunrenGuidanceEntry"));
var _KunrenGuidanceEntryResult = _interopRequireDefault(require("./kunrenGuidanceRegister/KunrenGuidanceEntryResult"));
var _KunrenMedplanEntry = _interopRequireDefault(require("./kunrenMedplanRegister/KunrenMedplanEntry"));
var _KunrenMedplanEntryResult = _interopRequireDefault(require("./kunrenMedplanRegister/KunrenMedplanEntryResult"));
var _KunrenReportDeleteResult = _interopRequireDefault(require("./kunrenReportRegister/KunrenReportDeleteResult"));
var _KunrenReportEntry = _interopRequireDefault(require("./kunrenReportRegister/KunrenReportEntry"));
var _KunrenReportEntryResult = _interopRequireDefault(require("./kunrenReportRegister/KunrenReportEntryResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ドキュメント管理（訓練）機能コンテナ
 */
class BcmKunrenContainer extends _react.default.Component {
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      dispContent,
      isNewWindow
    } = this.props;
    switch (dispContent) {
      case _bcmKunrenActions.CONTENTS.MAIN:
        return /*#__PURE__*/_react.default.createElement(_KunrenDocMngMain.default, {
          isNewWindow: isNewWindow
        });
      case _bcmKunrenActions.CONTENTS.REPORT_ENTRY:
        return /*#__PURE__*/_react.default.createElement(_KunrenReportEntry.default, null);
      case _bcmKunrenActions.CONTENTS.REPORT_ENTRY_RESULT:
        return /*#__PURE__*/_react.default.createElement(_KunrenReportEntryResult.default, null);
      case _bcmKunrenActions.CONTENTS.REPORT_DELETE_RESULT:
        return /*#__PURE__*/_react.default.createElement(_KunrenReportDeleteResult.default, null);
      case _bcmKunrenActions.CONTENTS.MEDPLAN_ENTRY:
        return /*#__PURE__*/_react.default.createElement(_KunrenMedplanEntry.default, null);
      case _bcmKunrenActions.CONTENTS.MEDPLAN_RESULT:
        return /*#__PURE__*/_react.default.createElement(_KunrenMedplanEntryResult.default, null);
      case _bcmKunrenActions.CONTENTS.GUIDANCE_ENTRY:
        return /*#__PURE__*/_react.default.createElement(_KunrenGuidanceEntry.default, null);
      case _bcmKunrenActions.CONTENTS.GUIDANCE_RESULT:
        return /*#__PURE__*/_react.default.createElement(_KunrenGuidanceEntryResult.default, null);
      case _bcmKunrenActions.CONTENTS.GUIDANCE_DELETE:
        return /*#__PURE__*/_react.default.createElement(_KunrenGuidanceDeleteResult.default, null);
      default:
        break;
    }
  }
}
exports.BcmKunrenContainer = BcmKunrenContainer;
const mapStateToProps = state => {
  return {
    dispContent: state.bcmKunren.dispContent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    clear: () => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BcmKunrenContainer);